import moment from 'moment';

import { APP_LOCAL_DATETIME_FORMAT, APP_LOCAL_DATETIME_FORMAT_Z } from 'app/shared/config/constants';

export const convertDateTimeFromServer = date => (date ? moment(date).format(APP_LOCAL_DATETIME_FORMAT) : null);

export const convertDateTimeToServer = date => (date ? moment(date, APP_LOCAL_DATETIME_FORMAT_Z).toDate() : null);

export const displayDefaultDateTime = () => moment().startOf('day').format(APP_LOCAL_DATETIME_FORMAT);

export const getDate = dateString => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().length === 1 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  const day = date.getDate().toString().length === 1 ? `0${date.getDate()}` : date.getDate();

  return `${day}/${month}/${year}`;
};

export const getDateEvent = dateString => {
  if (!dateString) return '';

  // const date =new Date(Date.parse(dateString));
  const date = moment(dateString, 'DD-MM-YYYY');
  const year = date.year().toString().substr(-2);
  const month = (date.month() + 1).toString().length === 1 ? `0${date.month() + 1}` : date.month() + 1;
  const day = date.date().toString().length === 1 ? `0${date.date()}` : date.date();
  return `${day}/${month}/${year}`;
};

export const getMonth = date => {
  const monthNames = [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Aout',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
  ];
  const d = new Date(date);
  const monthName = monthNames[d.getMonth()];
  return monthName;
};
